// تسجيل الجهاز لإشعارات الدفع عبر Firebase Messaging فقط (iOS + Android).
// يعيد سبباً خاماً دقيقاً عند الفشل لتسهيل التشخيص (أين تتوقّف العملية بالضبط).
import client from "../api/client";
import { isNative } from "./capacitor";

const save = async (token) => {
  const { Capacitor } = await import("@capacitor/core");
  await client.post("/devices/register", { token, platform: Capacitor.getPlatform(), source: "fcm" });
};

export const registerPush = async () => {
  if (!isNative()) return { registered: false, reason: "not_native" };
  const mod = await import("@capacitor-firebase/messaging").catch(() => null);
  if (!mod?.FirebaseMessaging) return { registered: false, reason: "plugin_unavailable" };
  const fm = mod.FirebaseMessaging;
  let perm;
  try {
    perm = await fm.requestPermissions();
  } catch (e) {
    return { registered: false, reason: "perm_error", error: String(e?.message || e).slice(0, 140) };
  }
  if (perm?.receive !== "granted") return { registered: false, reason: `perm_${perm?.receive || "denied"}` };
  let token;
  try {
    token = (await fm.getToken()).token;
  } catch (e) {
    return { registered: false, reason: "get_token_failed", error: String(e?.message || e).slice(0, 140) };
  }
  if (!token) return { registered: false, reason: "no_token" };
  try {
    await save(token);
  } catch (e) {
    return { registered: false, reason: "register_api_failed", error: String(e?.message || e).slice(0, 140) };
  }
  return { registered: true, provider: "fcm", token: `${token.slice(0, 14)}…` };
};
